import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
// import CookieConsent from "components/cookieConsent/CookieConsent";
import "index.css";
import * as serviceWorker from "serviceWorker";
import { MuiThemeProvider } from "@material-ui/core/styles";
import theme from "theme";
import GlobalCss from "components/GlobalCss";
import AOS from "aos";
import "aos/dist/aos.css";
// import { CookieContextProvider } from "./components/cookieConsent/CookieContext";

//@ts-ignore
// import TagManager from "react-gtm-module";

AOS.init();

// Internet Explorer 6-11
// @ts-ignore
const isIE = /*@cc_on!@*/ false || !!document.documentMode;

ReactDOM.render(
    <React.StrictMode>
        {isIE ? (
            <div style={{ color: "black" }}>
                Internet Explorer 11 is not supported, please use another browser.
            </div>
        ) : (
            <MuiThemeProvider theme={theme}>
                <GlobalCss>
                    {/* <CookieContextProvider
                        onPreferencesUpdate={(preferences) => {
                            if (preferences.marketingCookies.isEnabled) {
                                TagManager.initialize({
                                    gtmId: "GTM-MFLVJPP",
                                });
                            }
                        }}
                    > */}
                    {/* <CookieConsent /> */}
                    <BrowserRouter basename={process.env.PUBLIC_URL}>
                        <App />
                        <div
                            id="consent_blackbar"
                            style={{ position: "fixed", bottom: 0, zIndex: 100000, width: "100%" }}
                            className="consent-blackbar"
                        ></div>
                    </BrowserRouter>
                    {/* </CookieContextProvider> */}
                </GlobalCss>
            </MuiThemeProvider>
        )}
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
